import router from '@/router';
import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders, AxiosResponse, AxiosError } from 'axios';
import qs from 'qs';
import { config } from './config';

/* 第三方组件 */
import MobileDetect from 'mobile-detect';
import { ElMessageBox, ElMessage } from 'element-plus';
import { Session } from '../utils/storage';

const { result_code, base_url } = config;
const mobileMd = new MobileDetect(window.navigator.userAgent);

const service: AxiosInstance = axios.create({
	baseURL: base_url, // 接口请求地址，发布前请务必检查是否切换到生产环境
	timeout: config.request_timeout, // 请求超时时间
});

const decryptJWT = (token: string): any => {
	token = token.replace(/_/g, '/').replace(/-/g, '+');
	const json = decodeURIComponent(escape(window.atob(token.split('.')[1])));
	return JSON.parse(json);
};

const getJWTDate = (timestamp: number): Date => {
	return new Date(timestamp * 1000);
};

/* 请求拦截器 */
const requestUse = (config: InternalAxiosRequestConfig) => {
	const tokens = Session.get('token') as string;

	if (tokens) {
		const token = (str: any) => {
			try {
				return JSON.parse(str);
			} catch (e) {
				return str;
			}
		};
		config.headers['Authorization'] = `Bearer ${token(tokens)}`;
	}

	/* 表单数据请求 */
	if (config.method === 'post' && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
		config.data = qs.stringify(config.data);
	}

	// 判断 accessToken 是否过期(因为移动端混合，这里的跳转会有问题，暂时还是搁置吧
	// const jwt: any = decryptJWT(token);
	// const exp = getJWTDate(jwt.exp as number);

	// if (new Date() >= exp) { }

	/* 由于请求全部使用POST，所以这里没有意义（PS:全部POST有时好烦，想不通小桦桦的写法） */
	// if (config.method === 'get' && config.params) {
	//     let url = `${config.url as string}?`

	//     const keys = Object.keys(config.params)

	//     for (const key of keys) {
	//         if (config.params[key] !== void 0 && config.params[key] !== null) {
	//             url += `${key}=${encodeURIComponent(config.params[key])}&`
	//         }
	//     }

	//     url = url.substring(0, url.length - 1)
	//     config.params = {}
	//     config.url = url
	// }

	return config;
};

/* 请求拦截异常 */
const requestError = (error: AxiosError) => {
	Promise.reject(error);
};

/* 响应拦截器 */
const responseUse = (response: AxiosResponse<any>) => {
	if (response.config.responseType === 'blob') {
		return response;
	} else if (response.data.succeeded === result_code) {
		return response.data;
	} else {
		return response.data;
	}
};

/* 响应拦截器异常处理 */
const responseError = (error: AxiosError) => {
	if (error.response?.status == 401 || error.response?.status == 403) {
		Session.clear();
		// ElMessageBox({ title: '系统提示', message: '用户未登录或登录凭证已经失效，请重新登录。', lockScroll: false }).then(async () => {
		// 	if (!mobileMd.mobile()) {
		// 		router.replace({ path: '/login' });
		// 	} else {
		// 		router.replace({ path: '/mobile/login' });
		// 	}
		// });
	} else {
		if (error.message.indexOf('timeout') != -1) {
			ElMessage.error('网络超时');
		} else if (error.message == 'Network Error') {
			ElMessage.error('网络连接错误');
		}

		return Promise.reject(error);
	}
};

service.interceptors.request.use(requestUse, requestError);
service.interceptors.response.use(responseUse, responseError);

export { service };
